<script>
  import { diallerState } from "@sourcewhale/shared/src/svelte/src/pages/Dialler/diallerState.svelte.js";
  import { hasConversationsLicense } from "@sourcewhale/core";
  import {
    teamHasDiallerStore,
    userStore,
  } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Toggletip from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/Toggletip.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import {
    callAnsweredStore,
    candidatePhoneStore,
    candidateStore,
    todosModalItemStore,
  } from "../stores";
  import LearnMoreDialler from "./LearnMoreDialler.svelte";

  let closeDropdown;

  const makeListItemClick = (phoneNum) => () => {
    if (closeDropdown) closeDropdown();
    if (phoneNum) {
      // Explicitly pass a candidate object to Dialler
      const candidate = {
        candidateId: $candidateStore.candidateId,
        name: $candidateStore.name,
        phone: phoneNum,
        photo: $candidateStore.photo,
        jobTitle: $candidateStore.role,
        company: $candidateStore.company,
        role: "candidate",
      };

      const user = {
        id: $userStore.userId,
        name: $userStore.name,
        photo: $userStore.photo,
        jobTitle: $userStore.role,
        company: $userStore.company,
        role: "user",
      };

      // Only give dialler a todoId if it's not the contact modal and not an AI todo
      const todoId =
        $todosModalItemStore.toDoId && $todosModalItemStore.kind !== "aiToDo"
          ? $todosModalItemStore.toDoId
          : undefined;

      diallerState.makeCall([candidate, user], todoId);
      $callAnsweredStore[phoneNum] = true;
    }
  };

  const iconCls = (phoneObj) =>
    [
      "fa-regular",
      phoneObj.kind === "mobile" ? "fa-mobile" : "fa-phone",
      $callAnsweredStore[phoneObj.phone] ? "color-accentStatusSeaGreen" : "",
    ]
      .filter(Boolean)
      .join(" ");

  let disabledBtn;
</script>

{#if !$teamHasDiallerStore}
  <Toggletip placement="top" let:toggle
    ><LearnMoreDialler slot="toggletip" />
    <Button
      style="cursor: pointer"
      bind:el={disabledBtn}
      class="flex-1 disabled"
      onclick={toggle}
      leadingIcon="fa-regular fa-phone"
      trailingIcon=""
      size="large"
    >
      Call
    </Button>
  </Toggletip>
{:else if $candidatePhoneStore.length === 0 || $candidateStore.isDeleted || !hasConversationsLicense($userStore)}
  <Tooltip let:onmouseenter let:onmouseleave>
    <span slot="tooltip"
      >{hasConversationsLicense($userStore)
        ? "No phone numbers available."
        : "Using Dialer requires a Conversations license."}</span
    >
    <Button
      class="flex-1 disabled"
      leadingIcon="fa-regular fa-phone"
      trailingIcon=""
      size="large"
      {onmouseenter}
      {onmouseleave}
    >
      Call
    </Button>
  </Tooltip>
{:else if $candidatePhoneStore.length === 1}
  {@const phoneObj = $candidatePhoneStore[0] || {}}
  <Button
    class="flex-1"
    leadingIcon={iconCls(phoneObj)}
    trailingIcon=""
    size="large"
    onclick={makeListItemClick(phoneObj.phone)}
  >
    Call
  </Button>
{:else}
  <Dropdown
    class="flex-1"
    leadingIcon="fa-regular fa-phone"
    trailingIcon=""
    placement="top"
    size="large"
    bind:close={closeDropdown}
    ><span slot="button">Call</span>
    {#each $candidatePhoneStore as phoneObj}
      <ListItem
        onclick={makeListItemClick(phoneObj.phone)}
        icon={iconCls(phoneObj)}
      >
        {phoneObj.phone}
      </ListItem>
    {/each}
  </Dropdown>
{/if}
